const config = window.__APP_CONFIG__ || {};
// 开发环境强制走 devServer 代理（vue.config.js 中 /api -> 网关）：
// 运行时配置指向网关绝对地址时，浏览器直连会产生跨域预检（OPTIONS），
// 而网关对预检请求及携带 localhost Origin 的 POST 均返回 403，导致请求被拦截。
// 走 /api 代理后请求与页面同源，不再触发预检；生产环境仍使用 public/config.js 的运行时配置。
export const API_BASE_URL = process.env.NODE_ENV === 'development'
  ? '/api'
  : (config.API_BASE_URL || '');
export const WEBSOCKET_URL = config.WEBSOCKET_URL || '';
export default config;
